import React from "react";
import { ItemSnapshot } from "../../types/DB2";
import styled from "@emotion/styled";
import { formatStatusLabel } from "../../utils/status";

const Wrapper = styled.div`
  padding: 0.5rem 0 0.5rem 5.5rem;
  margin-left: 0rem;
  font-size: 0.95rem;
  color: inherit;
  background-color: white;
  border-left: 1px solid #e0e0e0;
`;

interface ListItemDetailsProps {
  itemSnapshot: ItemSnapshot;
}

const ListItemDetails: React.FC<ListItemDetailsProps> = ({ itemSnapshot }) => {
  const dropoff = itemSnapshot.dropoffGeo as
    | { latitude?: number; longitude?: number }
    | undefined;
  const latitude =
    dropoff && typeof dropoff.latitude === "number" && Number.isFinite(dropoff.latitude)
      ? dropoff.latitude
      : undefined;
  const longitude =
    dropoff && typeof dropoff.longitude === "number" && Number.isFinite(dropoff.longitude)
      ? dropoff.longitude
      : undefined;
  const accuracyMeters =
    typeof itemSnapshot.dropoffGeoAccuracyMeters === "number" &&
    Number.isFinite(itemSnapshot.dropoffGeoAccuracyMeters)
      ? Math.round(itemSnapshot.dropoffGeoAccuracyMeters)
      : undefined;

  return (
    <Wrapper>
      <div>
        <strong>Barcode ID:</strong> {itemSnapshot.barcodeId ?? "N/A"}
      </div>
      <div>
        <strong>Destination:</strong> {itemSnapshot.destination ?? "N/A"}
      </div>
      <div>
        <strong>Description:</strong> {itemSnapshot.description ?? ""}
      </div>
      <div>
        <strong>Status:</strong>{" "}
        {formatStatusLabel(itemSnapshot.status) || itemSnapshot.status || ""}
      </div>
      {latitude !== undefined && longitude !== undefined && (
        <div>
          <strong>GPS Coordinates:</strong>{" "}
          {latitude.toFixed(5)}, {longitude.toFixed(5)}
          {accuracyMeters !== undefined ? ` (±${accuracyMeters}m)` : ""}
        </div>
      )}
    </Wrapper>
  );
};

export default ListItemDetails;
